module.exports = __webpack_public_path__ + "static/img/accessData.a69fc55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/accessData.png
// module id = 61PB
// module chunks = 1 3 4 5 6 7